/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/api/request'; // 获取回执详情

export function getReceiptDetail(data) {
  return request.get('/settlement/receiptDetails', {
    params: data
  });
} // 获取回执拓展字段

export function getReceiptExtField(data) {
  return request.get( // '/v2/order/receiptExtFieldDetails',
  '/v2/settlement/receiptExtFieldDetails', {
    params: data
  });
} // 提交工单回执

export function getSaveReceipt(data) {
  return request.post('/settlement/saveReceipt', data);
} // 获取服务确认码

export function getVerifyCode(data) {
  return request.get('/settlement/getVerifyCode', {
    params: data
  });
}